 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];
 		var executeModules = data[2];

 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 		// add entry modules from loaded chunk to deferred list
 		deferredModules.push.apply(deferredModules, executeModules || []);

 		// run deferred modules when all chunks ready
 		return checkDeferredModules();
 	};
 	function checkDeferredModules() {
 		var result;
 		for(var i = 0; i < deferredModules.length; i++) {
 			var deferredModule = deferredModules[i];
 			var fulfilled = true;
 			for(var j = 1; j < deferredModule.length; j++) {
 				var depId = deferredModule[j];
 				if(installedChunks[depId] !== 0) fulfilled = false;
 			}
 			if(fulfilled) {
 				deferredModules.splice(i--, 1);
 				result = __webpack_require__(__webpack_require__.s = deferredModule[0]);
 			}
 		}

 		return result;
 	}

 	// The module cache
 	var installedModules = {};

 	// object to store loaded CSS chunks
 	var installedCssChunks = {
 		"runtime": 0
 	}

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		"runtime": 0
 	};

 	var deferredModules = [];

 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "" + {"0":"9252184","1":"152f598","2":"13dccca","3":"debc361","4":"5904f9c","5":"2b2ef20","6":"d78c51c","7":"94f7690","8":"d9a1021","9":"0c91787","10":"25c2cb4","11":"d71977e","12":"54e1709","13":"1150424","14":"23782b8","15":"f665503","16":"4454a48","17":"5605d6d","18":"fff9e85","19":"ec2f320","20":"1b8cb40","21":"fc0ef05","22":"468b197","23":"791caea","24":"e132cf8","25":"8d6deab","26":"bbed731","27":"b366c4f","28":"ff8107a","29":"02e352f","30":"336a424","31":"02fe13e","32":"f9266ba","33":"f42d197","34":"f6e0d39","35":"404e65f","36":"5a9a778","37":"90d1082","38":"1d6c0ce","39":"277d740","40":"81e7a18","41":"706c770","42":"e362066","43":"14919f7","44":"5315e37","45":"fda4e32","46":"8d5a7bd","47":"4726e0f","48":"8a246a1","49":"58af7ab","50":"2a752c3","51":"9588848","52":"37bd887","53":"b1806d4","54":"5fe8894","55":"3718975","56":"24dbafe","57":"5a6977c","58":"780ccf9","59":"53bd20d","60":"75bdb15","61":"f99a05b","62":"fafb622","63":"7276cdb","64":"440fd98","65":"344b8f3","66":"68a02d7","67":"960bf33","68":"f83aec5","69":"3e8e969","70":"cfb347f","71":"d2d195c","72":"baa7ecf","73":"e20ae47","74":"762b4ab","75":"aa30893","76":"ac4b897","77":"a54169d","78":"58090a5","79":"d9fc639","80":"5b59144","81":"e09afd0","82":"32ed529","83":"965a725","84":"68b8f12","85":"4d9a162","86":"4dcdf39","87":"a5778ae","88":"cfbb97a","89":"9b53b69","90":"e866eb5","91":"2f74c01","92":"739b010","93":"d779973","94":"659ae22","95":"26a9e91","96":"4f9cb32","97":"edf6f35","98":"a28e64b","99":"a4af1e5","100":"8d3fec6","101":"7f30191","102":"da27207","103":"730b065","104":"190aca1","105":"7867325","106":"bd1afa1","107":"fa633c2","108":"215e70a","109":"43da308","110":"60d4dfa","111":"120e0ef","112":"bb68185","113":"fe08097","114":"2cac9e0","115":"fb17ee6","components/delay-hydration":"dab6343","components/hot-accordion":"5effbc8","components/hot-accordion-item":"02ae6ad","components/hot-app-store-button":"67aef0e","components/hot-iframe-sso":"14bc39f","components/hot-organic-accordion":"bf2a877","components/hot-organic-accordion-item":"cebff04","components/hot-organic-accordion-item-custom":"887350c","components/hot-organic-button":"825b3db","components/hot-tag":"8a4f7f1","components/hot-video":"a08669a","components/hydration-status":"df7f154","lang-es-co.js":"67dbc76","lang-es-es.js":"1105ebe","lang-es-mx.js":"c5e9e0f","lang-es.js":"41c5bc1","lang-fr.js":"15f28ba","lang-it.js":"ec618a7","lang-jp.js":"ca1c7aa","lang-pt-br.js":"8f93f6a","pages/404":"1287fa7","pages/about":"37b4349","pages/affiliates":"9770444","pages/club":"a7a948d","pages/hotmart-app":"2ca3d2b","pages/is-hotmart-for-me":"4b62182","pages/lp-producer":"5ea6939","pages/members-area/index/pages/members-area/paid-media":"625bade","pages/members-area/index":"019e34c","pages/members-area/paid-media":"4b25234","pages/members-area/thank-you":"aee907a","pages/payments":"6750957","pages/pricing":"3913b2c","pages/producers":"15abc75","pages/sitemap":"9ee4d4a","pages/solutions":"c8fad8a","pages/tour/_id":"7f7f681","pages/tour/index":"507a3fd","vendors/pages/index":"c88d4ee","pages/index":"4071bed"}[chunkId] + ".modern.js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// extract-css-chunks-webpack-plugin CSS loading
 		var supportsPreload = (function() { try { return document.createElement("link").relList.supports("preload"); } catch(e) { return false; }}());
 		var linkExists = false
 		var cssChunks = {"0":1,"1":1,"2":1,"4":1,"5":1,"6":1,"7":1,"8":1,"9":1,"10":1,"11":1,"13":1,"14":1,"15":1,"17":1,"18":1,"19":1,"20":1,"21":1,"22":1,"23":1,"24":1,"25":1,"26":1,"27":1,"28":1,"29":1,"30":1,"31":1,"32":1,"33":1,"34":1,"35":1,"36":1,"37":1,"38":1,"39":1,"40":1,"41":1,"42":1,"43":1,"44":1,"45":1,"46":1,"47":1,"48":1,"49":1,"50":1,"51":1,"52":1,"53":1,"54":1,"55":1,"56":1,"57":1,"58":1,"59":1,"60":1,"61":1,"62":1,"63":1,"64":1,"65":1,"66":1,"67":1,"68":1,"69":1,"70":1,"71":1,"72":1,"73":1,"74":1,"75":1,"76":1,"77":1,"78":1,"79":1,"80":1,"81":1,"82":1,"83":1,"84":1,"85":1,"86":1,"87":1,"88":1,"89":1,"90":1,"91":1,"92":1,"93":1,"94":1,"95":1,"96":1,"97":1,"98":1,"99":1,"100":1,"101":1,"102":1,"103":1,"104":1,"105":1,"106":1,"107":1,"108":1,"109":1,"110":1,"111":1,"112":1,"113":1,"114":1,"115":1,"components/hot-accordion":1,"components/hot-accordion-item":1,"components/hot-app-store-button":1,"components/hot-iframe-sso":1,"components/hot-organic-accordion":1,"components/hot-organic-accordion-item":1,"components/hot-organic-accordion-item-custom":1,"components/hot-organic-button":1,"components/hot-tag":1,"components/hot-video":1,"pages/affiliates":1,"pages/club":1,"pages/hotmart-app":1,"pages/lp-producer":1,"pages/members-area/index/pages/members-area/paid-media":1,"pages/members-area/index":1,"pages/members-area/thank-you":1,"pages/pricing":1,"pages/solutions":1,"pages/index":1};
 		if(installedCssChunks[chunkId]) promises.push(installedCssChunks[chunkId]);
 		else if(installedCssChunks[chunkId] !== 0 && cssChunks[chunkId]) {
 			promises.push(installedCssChunks[chunkId] = new Promise(function(resolve, reject) {
 				var href = "css/" + {"0":"bc92dc3","1":"e62ce8b","2":"cbabb86","3":"31d6cfe","4":"cdcdb3d","5":"66645f7","6":"d8d62a2","7":"4007b79","8":"54a8347","9":"351380d","10":"19989c6","11":"c8112fa","12":"31d6cfe","13":"68c3433","14":"75e67e8","15":"39c5a44","16":"31d6cfe","17":"96c24c7","18":"9c4837c","19":"be814ea","20":"c32563d","21":"241ffb1","22":"e863632","23":"4188e7c","24":"5600e18","25":"0f3ddc3","26":"d70f182","27":"024b8d9","28":"c042bc4","29":"fdade79","30":"a04a862","31":"d75264e","32":"93aff2e","33":"ad26373","34":"80e4f98","35":"a020706","36":"eb8103c","37":"4468057","38":"08fe6d2","39":"064c4b1","40":"09c7f16","41":"ac4ef9f","42":"f75b75e","43":"689759f","44":"e48ac1d","45":"f3e0ea2","46":"99d4bdc","47":"00f530c","48":"de69fb0","49":"ab0e1fc","50":"26aad64","51":"56e0dd1","52":"727ff82","53":"fef25de","54":"5c5ce5e","55":"6e1d829","56":"f435948","57":"dd2d0c8","58":"62e0b0c","59":"34f525f","60":"30aa5b5","61":"72bfb9d","62":"b5d48e2","63":"f759bb7","64":"56abd46","65":"5535ef7","66":"df1bd4f","67":"c1e4f65","68":"3f9d89d","69":"3f53998","70":"047da8f","71":"c042bc4","72":"61d5c1c","73":"8e580b9","74":"ab64f81","75":"66645f7","76":"77a873c","77":"e4f3dcf","78":"f52ea8e","79":"b54ff1c","80":"5670dd5","81":"a5c4bdf","82":"848597c","83":"a2a2e07","84":"5a61a94","85":"8945d3a","86":"96b37b0","87":"972a3e4","88":"01bb85e","89":"9b60878","90":"85f5fcb","91":"b82956b","92":"77dcec5","93":"9e3df9d","94":"885540e","95":"d194fec","96":"76d7586","97":"ae59dbb","98":"bedc643","99":"fe5f52e","100":"df95389","101":"0a0f1f7","102":"80e10ea","103":"9b20e99","104":"f0d8317","105":"443998a","106":"573a98f","107":"d8beaf2","108":"6223a7e","109":"9a60522","110":"fcca9e1","111":"1d007c1","112":"f68e80c","113":"da26f13","114":"e22d49c","115":"11a0668","components/delay-hydration":"31d6cfe","components/hot-accordion":"ab64f81","components/hot-accordion-item":"5a2d087","components/hot-app-store-button":"935e4c5","components/hot-iframe-sso":"d66ab2d","components/hot-organic-accordion":"bd7f697","components/hot-organic-accordion-item":"1c5ba8d","components/hot-organic-accordion-item-custom":"c0c5be2","components/hot-organic-button":"c730dbd","components/hot-tag":"d70ca71","components/hot-video":"00c5276","components/hydration-status":"31d6cfe","lang-es-co.js":"31d6cfe","lang-es-es.js":"31d6cfe","lang-es-mx.js":"31d6cfe","lang-es.js":"31d6cfe","lang-fr.js":"31d6cfe","lang-it.js":"31d6cfe","lang-jp.js":"31d6cfe","lang-pt-br.js":"31d6cfe","pages/404":"31d6cfe","pages/about":"31d6cfe","pages/affiliates":"97f7dff","pages/club":"de22bd5","pages/hotmart-app":"8cca359","pages/is-hotmart-for-me":"31d6cfe","pages/lp-producer":"5691784","pages/members-area/index/pages/members-area/paid-media":"a222544","pages/members-area/index":"de22bd5","pages/members-area/paid-media":"31d6cfe","pages/members-area/thank-you":"e945570","pages/payments":"31d6cfe","pages/pricing":"be079d9","pages/producers":"31d6cfe","pages/sitemap":"31d6cfe","pages/solutions":"236939f","pages/tour/_id":"31d6cfe","pages/tour/index":"31d6cfe","vendors/pages/index":"31d6cfe","pages/index":"1455007"}[chunkId] + ".css";
 				var fullhref = __webpack_require__.p + href;
 				var existingLinkTags = document.getElementsByTagName("link");
 				for(var i = 0; i < existingLinkTags.length; i++) {
 					var tag = existingLinkTags[i];
 					var dataHref = tag.getAttribute("data-href") || tag.getAttribute("href");
 					if((tag.rel === "stylesheet" || tag.rel === "preload") && (dataHref === href || dataHref === fullhref)) {
 						linkExists = true
 						return resolve();
 					}
 				}
 				var existingStyleTags = document.getElementsByTagName("style");
 				for(var i = 0; i < existingStyleTags.length; i++) {
 					var tag = existingStyleTags[i];
 					var dataHref = tag.getAttribute("data-href");
 					if(dataHref === href || dataHref === fullhref) return resolve();
 				}
 				var linkTag = document.createElement("link");
 				linkTag.rel = supportsPreload ? "preload": "stylesheet";
 				supportsPreload ? linkTag.as = "style" : linkTag.type = "text/css";
 				linkTag.onload = resolve;
 				linkTag.onerror = function(event) {
 					var request = event && event.target && event.target.src || fullhref;
 					var err = new Error("Loading CSS chunk " + chunkId + " failed.\n(" + request + ")");
 					err.code = "CSS_CHUNK_LOAD_FAILED";
 					err.request = request;
 					delete installedCssChunks[chunkId]
 					linkTag.parentNode.removeChild(linkTag)
 					reject(err);
 				};
 				linkTag.href = fullhref;

 				var head = document.getElementsByTagName("head")[0]; head.appendChild(linkTag)
 			}).then(function() {
 				installedCssChunks[chunkId] = 0;
 				if(!linkExists && supportsPreload) {
 					var execLinkTag = document.createElement("link");
 					execLinkTag.href =  __webpack_require__.p + "css/" + {"0":"bc92dc3","1":"e62ce8b","2":"cbabb86","3":"31d6cfe","4":"cdcdb3d","5":"66645f7","6":"d8d62a2","7":"4007b79","8":"54a8347","9":"351380d","10":"19989c6","11":"c8112fa","12":"31d6cfe","13":"68c3433","14":"75e67e8","15":"39c5a44","16":"31d6cfe","17":"96c24c7","18":"9c4837c","19":"be814ea","20":"c32563d","21":"241ffb1","22":"e863632","23":"4188e7c","24":"5600e18","25":"0f3ddc3","26":"d70f182","27":"024b8d9","28":"c042bc4","29":"fdade79","30":"a04a862","31":"d75264e","32":"93aff2e","33":"ad26373","34":"80e4f98","35":"a020706","36":"eb8103c","37":"4468057","38":"08fe6d2","39":"064c4b1","40":"09c7f16","41":"ac4ef9f","42":"f75b75e","43":"689759f","44":"e48ac1d","45":"f3e0ea2","46":"99d4bdc","47":"00f530c","48":"de69fb0","49":"ab0e1fc","50":"26aad64","51":"56e0dd1","52":"727ff82","53":"fef25de","54":"5c5ce5e","55":"6e1d829","56":"f435948","57":"dd2d0c8","58":"62e0b0c","59":"34f525f","60":"30aa5b5","61":"72bfb9d","62":"b5d48e2","63":"f759bb7","64":"56abd46","65":"5535ef7","66":"df1bd4f","67":"c1e4f65","68":"3f9d89d","69":"3f53998","70":"047da8f","71":"c042bc4","72":"61d5c1c","73":"8e580b9","74":"ab64f81","75":"66645f7","76":"77a873c","77":"e4f3dcf","78":"f52ea8e","79":"b54ff1c","80":"5670dd5","81":"a5c4bdf","82":"848597c","83":"a2a2e07","84":"5a61a94","85":"8945d3a","86":"96b37b0","87":"972a3e4","88":"01bb85e","89":"9b60878","90":"85f5fcb","91":"b82956b","92":"77dcec5","93":"9e3df9d","94":"885540e","95":"d194fec","96":"76d7586","97":"ae59dbb","98":"bedc643","99":"fe5f52e","100":"df95389","101":"0a0f1f7","102":"80e10ea","103":"9b20e99","104":"f0d8317","105":"443998a","106":"573a98f","107":"d8beaf2","108":"6223a7e","109":"9a60522","110":"fcca9e1","111":"1d007c1","112":"f68e80c","113":"da26f13","114":"e22d49c","115":"11a0668","components/delay-hydration":"31d6cfe","components/hot-accordion":"ab64f81","components/hot-accordion-item":"5a2d087","components/hot-app-store-button":"935e4c5","components/hot-iframe-sso":"d66ab2d","components/hot-organic-accordion":"bd7f697","components/hot-organic-accordion-item":"1c5ba8d","components/hot-organic-accordion-item-custom":"c0c5be2","components/hot-organic-button":"c730dbd","components/hot-tag":"d70ca71","components/hot-video":"00c5276","components/hydration-status":"31d6cfe","lang-es-co.js":"31d6cfe","lang-es-es.js":"31d6cfe","lang-es-mx.js":"31d6cfe","lang-es.js":"31d6cfe","lang-fr.js":"31d6cfe","lang-it.js":"31d6cfe","lang-jp.js":"31d6cfe","lang-pt-br.js":"31d6cfe","pages/404":"31d6cfe","pages/about":"31d6cfe","pages/affiliates":"97f7dff","pages/club":"de22bd5","pages/hotmart-app":"8cca359","pages/is-hotmart-for-me":"31d6cfe","pages/lp-producer":"5691784","pages/members-area/index/pages/members-area/paid-media":"a222544","pages/members-area/index":"de22bd5","pages/members-area/paid-media":"31d6cfe","pages/members-area/thank-you":"e945570","pages/payments":"31d6cfe","pages/pricing":"be079d9","pages/producers":"31d6cfe","pages/sitemap":"31d6cfe","pages/solutions":"236939f","pages/tour/_id":"31d6cfe","pages/tour/index":"31d6cfe","vendors/pages/index":"31d6cfe","pages/index":"1455007"}[chunkId] + ".css";
 					execLinkTag.rel = "stylesheet";
 					execLinkTag.type = "text/css";
 					document.body.appendChild(execLinkTag);
 				}
 			}));
 		}

 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
 							error.name = 'ChunkLoadError';
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "/static/app-hotmart/";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["webpackJsonp"] = window["webpackJsonp"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// run deferred modules from other chunks
 	checkDeferredModules();
